import React, { useEffect, useState } from "react";
import "./AddUser.scss";

import InputField from "../../../components/InputField/InputField";
import CustomButton from "../../../components/CustomButton/CustomButton";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTES from "../../../constants/routes";
import { updateUserDetails } from "../../../api/userManagement";
import { toast } from "react-toastify";
import ToggleSwitch from "../../../components/ToggleSwitch/ToggleSwitch";
import { IoIosArrowBack, IoMdCloseCircle } from "react-icons/io";
import useUserIsAllowed from "../../../helpers/userAuthorized";
import { useDispatch, useSelector } from "react-redux";
import { updateUser } from "../../../redux/features/user-slice";
import { storage } from "../../../helpers/storage";
import ImageInput from "../../../components/ImageInput/ImageInput";

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

const AddUser = ({
  isEdit,
  isAdd,
  desktopView,
  selected,
  setSelectedDesktopTag,
  reload,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const addData = isAdd
    ? location.state?.addData
    : { name: "", email: "", status: true, image: { src: null, file: null } };

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm({});

  const [image, setImage] = useState({
    src: null,
    file: null,
  });

  const { id: currentUserId } = useSelector((state) => state.userReducer.value);

  const [submitting, setSubmitting] = useState(false);

  const [userId, setUserId] = useState(null);

  // const [openManageBranch, setOpenManageBranch] = useState(false);

  const userIsAllowedToAddEditUser = useUserIsAllowed("administrator");

  useEffect(() => {
    const editData =
      isEdit && desktopView ? selected : isEdit ? location.state?.editData : {};
    if (isEdit) {
      if (!editData?.id) {
        !desktopView && navigate(ROUTES.manageUser.path);
      } else {
        setUserId(editData?.id);
        reset({
          name: editData?.name,
          email: editData?.email,
          status: editData?.status,
        });

        if (editData?.image) {
          setImage({
            file: null,
            src: `${IMAGE_URL}/${editData?.image}`,
          });
        }
      }
    } else if (isAdd) {
      reset({
        name: addData?.name || "",
        email: addData?.email || "",
        status: addData?.status || true,
      });

      addData?.image && setImage(addData?.image);
    } else {
      reset({
        name: addData?.name || "",
        email: addData?.email || "",
        status: addData?.status || true,
      });
      setImage({
        file: null,
        src: null,
      });
    }
  }, [isEdit, location, selected]);

  const handleSumbitUser = (data) => {
    if (!isEdit) {
      navigate(desktopView ? "#" : ROUTES.addUserPassword.path, {
        state: {
          addData: {
            name: data?.name,
            email: data?.email,
            status: data?.status,
            image: image,
          },
        },
      });
      desktopView &&
        setSelectedDesktopTag &&
        setSelectedDesktopTag("Set Password");
    } else {
      if (userId) {
        setSubmitting(true);

        const userEditData = new FormData();

        userEditData.append("name", data?.name);
        userEditData.append("email", data?.email);
        userEditData.append(
          "status",
          data?.status === true || data?.status === 1
        );

        if (image.file) {
          userEditData.append("image", image.file);
        } else if (!image.src) {
          userEditData.append("image_remove", true);
        }

        updateUserDetails(userId, userEditData)
          .then((res) => {
            if (res.data?.id === currentUserId) {
              storage.set("userData", JSON.stringify(res.data));
              dispatch(updateUser(res.data));
            }
            toast.dismiss();
            toast.success("User details updated.");
            navigate(desktopView ? "#" : ROUTES.manageUserBranches.path, {
              state: { userData: { id: userId } },
            });
            desktopView && reload && reload(res.data);
          })
          .catch((err) => {
            if (err?.response?.data?.message) {
              if (err?.response?.data?.message === "User not authorized!") {
                toast.dismiss();
                toast.error(
                  "You do not have sufficient permissions to perform this action. Please contact your administrator."
                );
              } else {
                if (err?.response?.data?.errors) {
                  if (err?.response?.data?.errors?.name) {
                    toast.dismiss();
                    toast.error(`${err?.response?.data?.errors?.name}`);
                  } else if (err?.response?.data?.errors?.email) {
                    toast.dismiss();
                    toast.error(`${err?.response?.data?.errors?.email}`);
                  } else if (err?.response?.data?.errors?.password) {
                    toast.dismiss();
                    toast.error(`${err?.response?.data?.errors?.password}`);
                  } else {
                    toast.dismiss();
                    toast.error(`${err?.response?.data?.message}`);
                  }
                } else {
                  toast.dismiss();
                  toast.error(`${err?.response?.data?.message}`);
                }
              }
            } else {
              toast.dismiss();
              toast.error("Error while updating user detials!");
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      }
    }
  };
  return (
    <form
      aria-disabled={!userIsAllowedToAddEditUser}
      onSubmit={handleSubmit(handleSumbitUser)}
      className="add-user container-wrapper"
    >
      <div className="input-container">
        <ImageInput
          image={image}
          setImage={setImage}
          label={"User's Image"}
          featureAvailable={true}
          isAllowed={userIsAllowedToAddEditUser}
        />

        <InputField
          name={"name"}
          type={"text"}
          label={"User Name"}
          required={true}
          register={register}
          inputErrors={errors}
          watch={watch}
          disabled={!userIsAllowedToAddEditUser}
        />

        <InputField
          name={"email"}
          type={"email"}
          label={"Email"}
          required={true}
          register={register}
          inputErrors={errors}
          watch={watch}
          disabled={!userIsAllowedToAddEditUser}
        />

        <ToggleSwitch
          name={"status"}
          label={"Status"}
          register={register}
          required={false}
          showSVG={false}
          disabled={!userIsAllowedToAddEditUser}
        />

        <div className="buttons">
          <CustomButton
            name={isEdit ? "Save" : "Next"}
            color={"primary"}
            type={"submit"}
            handleSubmit={() => {}}
            disabled={submitting || !userIsAllowedToAddEditUser}
            bigButton={true}
            loader={submitting}
          />
        </div>
      </div>

      {/* {isEdit && user_id && (
        <ManageUserBranches
          open={openManageBranch}
          setOpen={setOpenManageBranch}
          selectedUser={editData}
        />
      )}

      {openManageBranch && (
        <div
          className="blur-back"
          onClick={() => {
            setOpenManageBranch(false);
          }}
        ></div>
      )} */}

      {/* {isEdit && user_id && (
        <div className="floating-button">
          <CustomButton
            name={`Manage Branches`}
            type={"button"}
            color={"primary"}
            bigButton={true}
            handleSubmit={() => {
              setOpenManageBranch(true);
            }}
            disabled={!isEdit || !user_id}
          />
        </div>
      )} */}

      {isEdit && userId && (
        <div
          className="navigation-back-button"
          onClick={() => {
            navigate(ROUTES.manageUserBranches.path, {
              state: { userData: { id: userId } },
            });
          }}
        >
          <IoIosArrowBack />
        </div>
      )}
    </form>
  );
};

export default AddUser;

// const ManageUserBranches = ({ open, setOpen, selectedUser }) => {
//   const { id: organization_id } = useSelector(
//     (state) => state.organizationReducer.value
//   );

//   const { branches: branchList } = useSelector(
//     (state) => state.branchReducer.value
//   );

//   const [submitting, setSubmitting] = useState(false);

//   const [branches, setBranches] = useState([]);

//   const [branchOptions, setBranchOptions] = useState([]);

//   const [availableChanges, setAvailableChanges] = useState(false);

//   useEffect(() => {
//     let options = branchList?.map((el) => {
//       return {
//         label: el?.name,
//         value: el?.id,
//       };
//     });
//     setBranchOptions(options);
//   }, [branchList]);

//   useEffect(() => {
//     if (selectedUser?.branches?.length > 0) {
//       const userActiveOrgBranches = selectedUser?.branches?.filter(
//         (el) => el?.organization_id === organization_id
//       );
//       setBranches(userActiveOrgBranches);
//     } else {
//       setBranches([]);
//     }
//   }, [selectedUser]);

//   useEffect(() => {
//     const userActiveOrgBranches = selectedUser?.branches?.filter(
//       (el) => el?.organization_id === organization_id
//     );
//     let change = false;

//     if (branches?.length === userActiveOrgBranches?.length) {
//       for (const el of userActiveOrgBranches || []) {
//         const exists = branches?.find((item) => item?.id === el?.id);
//         if (exists) {
//           change = false;
//         } else {
//           change = true;
//           break;
//         }
//       }
//       for (const el of branches || []) {
//         const exists = userActiveOrgBranches?.find(
//           (item) => item?.id === el?.id
//         );
//         if (exists) {
//           change = false;
//         } else {
//           change = true;
//           break;
//         }
//       }
//     } else {
//       change = true;
//     }

//     setAvailableChanges(change);
//   }, [branches]);

//   const handleSubmit = () => {
//     if (branches?.length > 0 && selectedUser?.id) {
//       const userData = branches.map((el) => {
//         return el?.id;
//       });

//       setSubmitting(true);

//       updateUserBranches(selectedUser?.id, userData)
//         .then((res) => {
//           toast.dismiss(); toast.success("User Branches updated sucessfully.");
//           setOpen(false);
//         })
//         .catch((err) => {
//           if (err?.response?.data?.message) {
//             if (err?.response?.data?.message === "User not authorized!") {
//               toast.dismiss(); toast.error(
//                 "You do not have sufficient permissions to perform this action. Please contact your administrator."
//               );
//             } else {
//               toast.dismiss(); toast.error(`${err?.response?.data?.message}`);
//             }
//           } else {
//             toast.dismiss(); toast.error("Error while updating user branches!");
//           }
//         })
//         .finally(() => {
//           setSubmitting(false);
//         });
//     }
//   };

//   const addBranch = (opt) => {
//     const selectedBranch = branchList?.find((el) => el?.id === opt?.value);
//     const alreadyExists = branches?.find((el) => el?.id === opt?.value);
//     if (selectedBranch) {
//       if (alreadyExists) {
//         toast.dismiss(); toast.info(`${alreadyExists?.name} already exist for this user!`);
//       } else {
//         const tempArray = [...branches];
//         tempArray.unshift(selectedBranch);
//         setBranches(tempArray);
//       }
//     }
//   };

//   const removeBranch = (index) => {
//     if (branches?.length > 1) {
//       const tempArray = [...branches];
//       tempArray.splice(index, 1);
//       setBranches(tempArray);
//     } else {
//       toast.dismiss(); toast.info(`User must have atleast one branch!`);
//     }
//   };

//   return (
//     <>
//       <div className={`manage-user-branches ${open ? "active" : ""}`}>
//         <h1>Manage {selectedUser?.name}'s Branches</h1>

//         <InputSelect
//           options={branchOptions}
//           value={{ label: "", value: "" }}
//           register={() => {}}
//           required={true}
//           name="branch"
//           handleChange={(opt) => {
//             addBranch(opt);
//           }}
//           reset={() => {}}
//           label={"Add Branch"}
//           inputErrors={{}}
//         />

//         <div className="branch-list">
//           {branches?.length > 0 ? (
//             branches.map((el, i) => {
//               return (
//                 <div className="item" key={i}>
//                   <p className="name">{el?.name || "Branch Name"}</p>
//                   <FaTrash
//                     onClick={() => {
//                       removeBranch(i);
//                     }}
//                   />
//                 </div>
//               );
//             })
//           ) : (
//             <p>User does not have any branches listed to their name.</p>
//           )}
//         </div>

//         <div className="buttons">
//           <CustomButton
//             name={"Cancel"}
//             color={"danger"}
//             type={"button"}
//             handleSubmit={() => {
//               setOpen(false);
//             }}
//             disabled={submitting}
//           />
//           <CustomButton
//             name={"Update"}
//             color={"primary"}
//             type={"button"}
//             handleSubmit={handleSubmit}
//             disabled={submitting || !availableChanges}
//           />
//         </div>
//       </div>
//     </>
//   );
// };
